<tt-page>
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <div class="col-xs-12">
            <tt-button
                *ngFor="let view of views"
                [ttText]="view.label"
                [ttIcon]="selectedView === view.id ? 'fas fa-check' : ''"
                (ttClick)="selectView(view.id)">
            </tt-button>
        </div>

        <div *ngIf="selectedView === '2'" class="col-xs-12">
            <div class="col-xs-6">
                <tt-button ttText="notification_mark_all" [ttLocked]="locked" ttType="primary" ttIcon="glyphicon glyphicon-check" ttTextAlign="center" (ttClick)="markNotification()"></tt-button>
            </div>
            <div class="col-xs-6">
                <tt-button ttText="notification_confirm_marked" [ttLocked]="locked" ttType="success" ttIcon="fas fa-download" ttTextAlign="center" (ttClick)="confirmMarkNotifications()"></tt-button>
            </div>
        </div>

        <form *ngIf="!!setting" (ngSubmit)="onSearchBlur()" (focusout)="onSearchBlur()">
            <tt-input
                ttLabel="searchtext"
                [(ttModel)]="setting.searchtext"
                (ttModelChange)="onSearchTextChanged($event)"
                [ttButtons]="searchButtons">
            </tt-input>
        </form>
    </tt-card>

    <div *ngIf="selectedView === '0'" class="col-xs-12 col-md-6 sp-0">
        <tt-list [ttData]="unreadNotifications" [ttFilter]="setting?.searchtext ?? ''" (ttClick)="readNotification($event.item, $event.event)"></tt-list>
    </div>

    <div *ngIf="selectedView === '1'" class="col-xs-12 col-md-6 sp-0">
        <tt-list [ttData]="readNotifications" [ttFilter]="setting?.searchtext ?? ''" (ttClick)="readNotification($event.item, $event.event)"></tt-list>
    </div>

    <div *ngIf="selectedView === '2'" class="col-xs-12 col-md-6 sp-0">
        <tt-list [ttData]="unreadNotifications" [ttFilter]="setting?.searchtext ?? ''" ttCheckboxSelection ttGoto="false"></tt-list>
    </div>
</tt-page>
